import React from 'react';
import LocationSettings from '../setting_components/LocationSettings';

class SignUpLocation extends React.Component {
  render() {
    return (
      <div className="onboarding-page-wrap">
        <div className="onboarding-page">
          <header className="onboarding-welcome-hero">
            <h1 className="onboarding-welcome-hero__title">
              Welcome!{' '}
              <span className="onboarding-welcome-hero__wave" aria-hidden="true">
                👋
              </span>
            </h1>
            <p className="onboarding-welcome-hero__tagline">
              <span>Let&apos;s start your</span>
              <span>language journey</span>
            </p>
          </header>
          <LocationSettings signup={true} variant="dash" />
        </div>
      </div>
    );
  }
}

export default SignUpLocation;
